export const logoutChannel = new BroadcastChannel("auth-logout");

logoutChannel.addEventListener("message", (event) => {
  if (event.data === "logout") {
    window.location.href = "/welcome/login";
  }
});

// The session cookie is shared by every tab, so logging into another account
// in one tab silently moves the others onto it while they still show the
// previous account's data, and their requests fail with 403 (DISPATCHER-CX).
// Each tab announces the user it loaded here so the others can notice.
export const sessionChannel = new BroadcastChannel("auth-session");

export type SessionAnnouncement = { type: "session"; userId: string };

export const isSessionAnnouncement = (
  data: unknown
): data is SessionAnnouncement =>
  typeof data === "object" &&
  data !== null &&
  (data as SessionAnnouncement).type === "session" &&
  typeof (data as SessionAnnouncement).userId === "string";
